import React from 'react';
import { MOBILE_OPPONENT_DRONE_ROW_TOP_PX, MOBILE_OPPONENT_DRONE_SCALE } from './mobileBattleLayoutOffsets';
import { getOrderCardImageSrc } from '../../utils/orderCardImageSrc';

/**
 * Mobile Opponent Drones Component
 * Positioned at top-right corner
 */
export const MobileOpponentDrones = ({
  opponent,
  droneRenderEntries = null,
}) => {
  const entries = droneRenderEntries ?? (opponent?.drones || [])
    .map((drone, index) => (drone && !drone.markedForRemoval ? { drone, index, isGhost: false } : null))
    .filter(Boolean);

  return (
    <div
      className="opponent-drone-zone-mobile"
      style={{
        position: "absolute",
        top: `${MOBILE_OPPONENT_DRONE_ROW_TOP_PX}px`,
        right: "5px",
        zIndex: 1002,
        display: "flex",
        gap: "2px",
        flexDirection: "row",
        transform: `scale(${MOBILE_OPPONENT_DRONE_SCALE})`,
        transformOrigin: "top right"
      }}
    >
      {entries.map(({ drone, index, isGhost }) => (
        <div
          key={`mobile-opponent-drone-${drone.instanceId || index}`}
          className="drone-slot-bounds"
          data-drone-zone="opponent_drone"
          data-drone-index={index}
          data-instance-id={drone.instanceId || ''}
          style={{
            width: '80px',
            height: '60px',
            backgroundColor: '#333',
            border: '2px solid #a02c2c',
            borderRadius: '4px',
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'visible',
            pointerEvents: isGhost ? 'none' : 'auto',
          }}
        >
          <img 
            src={getOrderCardImageSrc(drone)}
            alt={drone.name}
            style={{
              width: '70px',
              height: '50px',
              objectFit: 'contain'
            }}
          />
          {drone.charges !== undefined && (
            <div style={{
              position: 'absolute',
              top: '-8px',
              right: '-8px',
              backgroundColor: '#a02c2c',
              color: 'white',
              borderRadius: '50%',
              width: '20px',
              height: '20px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '11px',
              fontWeight: 'bold'
            }}>
              {drone.charges}
            </div>
          )}
        </div>
      ))}
      {/* Empty drone slots */}
      {Array.from({ length: 4 - entries.length }).map((_, index) => (
        <div
          key={`mobile-empty-opponent-drone-${index}`}
          style={{
            width: '80px',
            height: '60px',
            backgroundColor: '#333',
            border: '2px solid #555',
            borderRadius: '4px',
            opacity: 0.3
          }}
        />
      ))}
    </div>
  );
};

export default MobileOpponentDrones;
